import React, { useState, useEffect } from 'react';
import css from './css/AddEditQuestionOptionModal.scss';
import commonCss from './css/SurveyStyle.scss';
import classnames from 'classnames';
import Modal from 'react-modal';
import Header from 'common/Header';
import Footer from 'common/Footer';
import StyledButton from 'common/StyledButton';
import { isEmptyString } from 'utils/text';
import Icon from 'SF/MaterialIcon';
import PropTypes from 'prop-types';

const AddEditQuestionOptionModal = ({isOpen, closeModal, currentOptions, optionTextToEdit, isEdit, onSave}) => {
    const [option, setOption] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        setOption(isEdit ? optionTextToEdit : '');
        setError('');
    }, [optionTextToEdit, isOpen]);

    const validate = () => {
        if (isEmptyString(option)) {
            setError('Provide option text.');
        } else if (currentOptions.some(currentOption => currentOption.text === option)) {
            setError('This option already exists for this question.');
        } else {
            onSave(option);
            closeModal();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            overlayClassName={css['overlay']}
            className={css['modal']}
            shouldCloseOnOverlayClick={false}
            contentLabel={`${isEdit ? 'Edit' : 'Add'} Question Option`}
        >
            <div className={css['container']}>
                <Header closeModal={closeModal} />
                <div className={css['content']}>
                    <div className={commonCss['header-third-level']}>{isEdit ? 'Edit' : 'Add'} Question Option</div>
                    <div className={css['option-input']}>
                        <label htmlFor='question-option' className={classnames(commonCss['field-label'], {[commonCss['error']]: !!error})}>
                            Option
                        </label>
                        <input
                            id='question-option'
                            className={classnames(css['input'], {[css['inputError']]: !!error})}
                            type='text'
                            value={option}
                            onChange={e => { setOption(e.target.value); setError(''); }}
                            required
                        />
                        {error && <div className={commonCss['field-error']} role='alert'><Icon icon='error' aria-hidden />{error}</div>}
                    </div>
                </div>
                <Footer
                    primaryButton={<StyledButton onClick={validate}>Save Option</StyledButton>}
                    secondaryButton={<StyledButton asLink onClick={closeModal}>Cancel</StyledButton>}
                />
            </div>
        </Modal>
    );
};

AddEditQuestionOptionModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    currentOptions: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        position: PropTypes.number.isRequired
    })).isRequired,
    optionTextToEdit: PropTypes.string,
    isEdit: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired
};

export default AddEditQuestionOptionModal;
